import $ from "jquery";
import tbxHandleFilterPage from '../sections/filter-list.js';

if ( $('.cumulo-degreeprograms').length )
{
	console.log('degreesprograms.js');
	tbxHandleFilterPage();
}